import { render, staticRenderFns } from "./DTPListModal.vue?vue&type=template&id=da6eb3a8&scoped=true&"
import script from "./DTPListModal.vue?vue&type=script&lang=js&"
export * from "./DTPListModal.vue?vue&type=script&lang=js&"
import style0 from "./DTPListModal.vue?vue&type=style&index=0&id=da6eb3a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6eb3a8",
  null
  
)

export default component.exports